import type { $Fetch } from 'ofetch';
import type { Nota, LancarNotaCommand } from '@/domain/model/Nota';
import type { NotaGateway } from '@/application/port/out/NotaGateway';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

/** FASE C.2 — gateway HTTP para /api/v1/notas (assessment slice). */
export class HttpNotaGateway implements NotaGateway {
  constructor(private readonly client: $Fetch) {}

  async listByMatricula(matriculaId: string, disciplineId?: string): Promise<Nota[]> {
    const params: Record<string, string> = { matriculaId };
    if (disciplineId) params['disciplineId'] = disciplineId;
    const res = await this.client<ApiResponse<Nota[]>>('/api/v1/notas', {
      method: 'GET', params,
    });
    assertApiSuccess(res);
    return res.data;
  }

  async lancar(command: LancarNotaCommand): Promise<Nota> {
    const res = await this.client<ApiResponse<Nota>>('/api/v1/notas', {
      method: 'POST',
      body: {
        matriculaId: command.matriculaId,
        disciplineId: command.disciplineId,
        avaliacaoId: command.avaliacaoId,
        origem: command.origem,
        etapa: command.etapa ?? null,
        valor: command.valor,
        peso: command.peso,
        motivo: command.motivo,
      },
    });
    assertApiSuccess(res);
    return res.data;
  }
}
